var _g, _g2, _g3, _g4, _g5, _g6, _g7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconRevision(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "revision",
    xmlns: "http://www.w3.org/2000/svg",
    width: 152.98,
    height: 199.81,
    viewBox: "0 0 152.98 199.81",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_6353",
    "data-name": "Group 6353"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6352",
    "data-name": "Group 6352"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14665",
    "data-name": "Path 14665",
    d: "M135.418,23.805H117.466V17.561a5.854,5.854,0,0,0-5.854-5.854H93.048a17.563,17.563,0,0,0-33.117,0H40.977a5.854,5.854,0,0,0-5.854,5.854v6.244H17.561A17.581,17.581,0,0,0,0,41.367V182.249A17.581,17.581,0,0,0,17.561,199.81H135.418a17.581,17.581,0,0,0,17.561-17.561V41.367A17.581,17.581,0,0,0,135.418,23.805Zm-88.588-.39H64.782a5.854,5.854,0,0,0,5.854-5.854,5.854,5.854,0,1,1,11.708,0A5.854,5.854,0,0,0,88.2,23.415h17.561v6.244a5.86,5.86,0,0,1-5.854,5.854H52.684a5.86,5.86,0,0,1-5.854-5.854Zm94.441,158.833a5.86,5.86,0,0,1-5.854,5.854H17.561a5.86,5.86,0,0,1-5.854-5.854V41.367a5.86,5.86,0,0,1,5.854-5.854H36.13A17.589,17.589,0,0,0,52.684,47.221H99.905A17.589,17.589,0,0,0,116.46,35.513h18.959a5.86,5.86,0,0,1,5.854,5.854Z",
    fill: "#fff"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6355",
    "data-name": "Group 6355",
    transform: "translate(23.415 99.905)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6354",
    "data-name": "Group 6354"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14666",
    "data-name": "Path 14666",
    d: "M105.54,257.749a5.853,5.853,0,0,0-8.278-.068L77.6,277.025l-7.6-7.6a5.854,5.854,0,0,0-8.278,8.278l11.708,11.708a5.854,5.854,0,0,0,8.244.034l23.806-23.415A5.854,5.854,0,0,0,105.54,257.749Z",
    transform: "translate(-59.999 -256)",
    fill: "#fff"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6357",
    "data-name": "Group 6357",
    transform: "translate(23.415 140.882)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6356",
    "data-name": "Group 6356"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14667",
    "data-name": "Path 14667",
    d: "M105.54,362.749a5.853,5.853,0,0,0-8.278-.068L77.6,382.025l-7.6-7.6a5.854,5.854,0,0,0-8.278,8.278l11.708,11.708a5.853,5.853,0,0,0,8.244.034l23.806-23.415A5.854,5.854,0,0,0,105.54,362.749Z",
    transform: "translate(-59.999 -361)",
    fill: "#fff"
  })))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6359",
    "data-name": "Group 6359",
    transform: "translate(23.415 58.929)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6358",
    "data-name": "Group 6358"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14668",
    "data-name": "Path 14668",
    d: "M93.408,176.13l-7.569-7.569,7.568-7.568a5.854,5.854,0,0,0-8.278-8.278l-7.568,7.568-7.569-7.568a5.854,5.854,0,0,0-8.278,8.278l7.569,7.568-7.568,7.568a5.854,5.854,0,0,0,8.278,8.279l7.568-7.569,7.569,7.569a5.854,5.854,0,0,0,8.278-8.278Z",
    transform: "translate(-60 -151)",
    fill: "#fff"
  })))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6361",
    "data-name": "Group 6361",
    transform: "translate(82.344 70.636)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6360",
    "data-name": "Group 6360"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14669",
    "data-name": "Path 14669",
    d: "M252.367,181H216.854a5.854,5.854,0,1,0,0,11.708h35.513a5.854,5.854,0,1,0,0-11.708Z",
    transform: "translate(-211 -181)",
    fill: "#fff"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6363",
    "data-name": "Group 6363",
    transform: "translate(82.344 111.613)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6362",
    "data-name": "Group 6362"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14670",
    "data-name": "Path 14670",
    d: "M252.367,286H216.854a5.854,5.854,0,1,0,0,11.708h35.513a5.854,5.854,0,1,0,0-11.708Z",
    transform: "translate(-211 -286)",
    fill: "#fff"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group_6365",
    "data-name": "Group 6365",
    transform: "translate(82.344 152.589)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_6364",
    "data-name": "Group 6364"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_14671",
    "data-name": "Path 14671",
    d: "M252.367,391H216.854a5.854,5.854,0,1,0,0,11.708h35.513a5.854,5.854,0,1,0,0-11.708Z",
    transform: "translate(-211 -391)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRevision);
export default __webpack_public_path__ + "static/media/icon-revision.2442daad.svg";
export { ForwardRef as ReactComponent };